<template>
  <div class="tab-content sort-type" id="act-jnl-list-template">
    <div class="active-board-container">
      <div class="active-board-title">
        <div class="tit">{{ ANN_NM }}</div>
        <p>세부사업명: {{ BIZNM }}</p>
      </div>

      <div class="active-content-grid">
        <div class="active-info-card" v-for="(result, index) in list" :key="index">
          <h4>교육 정보</h4>
          <div class="table-wrap">
            <table class="table-body-only">
              <caption>교육 정보 테이블</caption>
              <colgroup class="pc-cell">
                <col style="width: 160px;" />
                <col />
              </colgroup>
              <colgroup class="mo-cell">
                <col style="width: 88px;" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">교육 구분</th>
                  <td>일반 교육</td>
                </tr>
                <tr>
                  <th scope="row">참여자 상태</th>
                  <td>{{ result.EDU_ING_STEP_NM }}</td>
                </tr>
                <tr>
                  <th scope="row">교육일수</th>
                  <td>{{ result.EDU_DAY }}</td>
                </tr>
                <tr>
                  <th scope="row">교육시간</th>
                  <td>{{ result.EDU_TM }}</td>
                </tr>
                <tr>
                  <th scope="row">교육 포기일</th>
                  <td>{{ result.GIVEUPDATE }}</td>
                </tr>
                <tr>
                  <th scope="row">교육 수료증</th>
                  <td>
                    <button type="button" class="btn btn-primary btn-xsm" @click="eduCompReport(result.APP_NO)" v-if="result.EDU_APPRV_STAT === 'JB38001'">출력</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="active-info-card">
          <h4>활동 월 검색</h4>
          <div class="table-wrap">
            <table class="table-body-only">
                <caption>활동 월 검색 테이블</caption>
                <colgroup class="pc-cell">
                  <col style="width: 160px;" />
                  <col />
                </colgroup>
                <colgroup class="mo-cell">
                  <col style="width: 88px;" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">활동 년</th>
                    <td>
                      <div class="input-area mo-size wid160">
                        <select title="활동 연도 선택" v-model="SRCH_ACCYYYY">
                          <option v-for="(year, index) in years" :key="index" :value="year">{{ year }}</option>
                        </select>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">활동 월</th>
                    <td>
                      <div class="input-area mo-size wid160">
                        <select title="활동 월 선택" v-model="SRCH_ACCMM">
                          <option v-for="(month, index) in months" :key="index" :value="month">{{ month }}</option>
                        </select>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="button-area gap10 mt-16">
              <button type="button" class="btn btn-primary btn-xsm" @click="getJnlList">검색</button>
            </div>
          </div>

          <div class="active-info-card">
            <h4>활동 정보 요약</h4>
            <div class="table-wrap">
              <table class="table-body-only">
                <caption>활동 정보 요약 테이블</caption>
                <colgroup class="pc-cell">
                  <col style="width: 160px;" />
                    <col />
                </colgroup>
                <colgroup class="mo-cell">
                  <col style="width: 88px;" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th>활동처명</th>
                    <td>{{ ACTCOMP_NM }}</td>
                  </tr>
                  <tr>
                    <th>참여자 상태</th>
                    <td>{{ ACT_ING_STEP_NM }}</td>
                  </tr>
                  <tr>
                    <th>활동일수</th>
                    <td>{{ ActJnlResult.MT_REG_ACT_DAY }}</td>
                  </tr>
                  <tr>
                    <th>활동시간</th>
                    <td>{{ ActJnlResult.MT_REG_ACT_TM }}</td>
                  </tr>
                  <tr>
                    <th>관리자 확정일수</th>
                    <td>{{ ActJnlResult.MT_ADMIT_ACT_DAY }}</td>
                  </tr>
                  <tr>
                    <th>관리자 확정시간</th>
                    <td>{{ ActJnlResult.MT_ADMIT_ACT_TM }}</td>
                  </tr>
                </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
    <div class="button-area gap10 flex-end" v-if="ACT_ING_STEP === 'JB29002' || ACT_ING_STEP === 'JB29003'">
      활동일지 목록
      <button type="button" class="btn btn-primary btn-xsm" @click="actJnlRgst">활동일지 작성</button>
    </div>

    <div class="job-list-container">
      <div class="job-card-grid">
        <div class="job-card" v-for="(result, index) in actJnlList" :key="index">
          <div class="card-header flex-justify-between">
            <span class="full-date">{{ result.ACT_DE }}</span>
            <span class="status-badge status-darkblue">{{ result.DAILDOC_CFM_STAT_NM }}</span>
          </div>
          <div class="card-body">
            <a href="#" class="title-line" title="{{ result.ACT_SJ }} 상세보기">
              {{ result.ACT_SJ }}
            </a>
            <div class="recruitment-info mt-16">
              <span>구분 <strong class="bar">{{ result.ACT_SE_NM }}</strong></span>
              <span>시작시간 <strong class="bar">{{ result.ACT_STTM }}</strong></span>
              <span>종료시간 <strong class="bar">{{ result.ACT_EDTM }}</strong></span>
              <span>활동시간 <strong class="bar">{{ result.ACT_TM }}</strong></span>
              <span>중식 <strong class="bar">{{ result.LUNCH_CD_NM }} </strong></span>
              <span>석식 <strong class="bar">{{ result.DINNER_CD_NM }} </strong></span>
              <span>인정시간 <strong class="bar">{{ result.ADMIT_ACT_TM }}</strong></span>
            </div>
            <div class="button-area mypage-type1 mt-0">
              <a href="javascript:void(0)" class="btn btn-primary btn-md" @click="actJnlView(result.SEQ)" title="수정/조회">수정/조회</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-area gap10 mt-16">
      <button type="button" class="btn btn-primary btn-xsm" @click="goActList()">목록</button>
    </div>
    <act-jnl-detail-modal :mode="jnlmode" :actJnlDetailModal="actJnlDetailModal" :JNL_SEQ="selectedSeq" :bindData="actJnlBindData" @update:actJnlDetailModal="actJnlDetailModal = $event" @reloadList="getJnlList">
    </act-jnl-detail-modal>
  </div>
</template>

<script>
import Axios from 'axios';
import ActJnlDetailModal from './ActJnlDetail.vue';

export default {
  name: 'act-jnl-list-template',
  props: ['annKindType', 'annNo', 'actCompNo', 'appNo'],
  components: {
    ActJnlDetailModal,
  },
  data() {
    return {
      ACTCOMP_NO: this.actCompNo,
      ANN_NO: this.annNo,
      list: [
        {
          ADDR: '-',
          ANN_NM: '-',
          ANN_NO: 0,
          APPLCNT_ID: '-',
          APPLCNT_NM: '-',
          APP_NO: this.appNo,
          BIRTHDE: '-',
          BIZNM: '-',
          BIZ_YEAR: '-',
          CUR_STAT_CD: '-',
          EDU_APPRV_STAT: '-',
          EDU_DAY: '-',
          EDU_ING_STEP: '-',
          EDU_ING_STEP_NM: '-',
          EDU_TM: '-',
          EMAIL: '-',
          GENDER: '-',
          GIVEUPDATE: '-',
          HP_1: '-',
          HP_2: '-',
          HP_3: '-',
          INFO4: '-',
          RN: '-',
          SRCH_EDU_ED: '-',
          SRCH_EDU_ST: '-',
          WORK_EDU_TM: '-',
          ZIPCODE: '-',
        },
      ],
      ActJnlResult: {},
      years: this.generateYears(),
      SRCH_ACCYYYY: new Date().getFullYear().toString(),
      SRCH_ACCMM: new Date().toISOString().slice(5, 7),
      months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      actJnlList: [],
      APP_NO: this.appNo,
      BIZNM: '',
      ANN_NM: '',
      actJnlDetailModal: false,
      ACTAMT_HAMT: '',
      selectedSeq: 0,
      ACCYYYY: '',
      ACCMM: '',
      jnlmode: '', // Regist, Modify, View
      actJnlBindData: {
        ANN_NO: 0,
        APP_NO: this.appNo,
        BIZNM: '',
        ACCYYYY: '',
        ACCMM: '',
        ACTCOMP_NO: 0,
        ACTAMT_HAMT: 0,
        ANN_ACTCOMP_NO: 0,
      },
      APPLCNT_NM: '',
      ANN_ACTCOMP_NO: 0,
      ACTCOMP_NM: '',
      ACT_ING_STEP_NM: '',
      ACT_ING_STEP: '',
    };
  },
  watch: {},
  methods: {
    generateYears() {
      const currentYear = new Date().getFullYear();
      const startYear = 2018;
      const years = [];

      for (let year = currentYear; year >= startYear; year -= 1) {
        years.push(year.toString());
      }

      return years;
    },
    getJnlMonthList() {
      const params = {
        ACCYYYY: this.SRCH_ACCYYYY,
        ACTCOMP_NO: this.ACTCOMP_NO,
        ANN_NO: this.ANN_NO,
        APP_NO: this.APP_NO,
      };
      Axios
        .get('/api/act/actJnlMonthList', { params })
        .then((response) => {
          console.log(response);
          const result = response.data.data;
          if (result.list && result.list.length > 0) this.list = result.list;
          this.ActJnlResult = result.ActJnlResult;
          this.APPLCNT_NM = result.ActJnlResult.APPLCNT_NM;

          // 서버 데이터가 있으면 사용, 없으면 기본 생성된 years 사용
          if (result.years && result.years.length > 0) {
            this.years = result.years.map(item => item.BIZ_YEAR);
          }

          this.SRCH_ACCYYYY = result.currentYear || new Date().getFullYear().toString();
          this.SRCH_ACCMM = result.currentMonth || new Date().toISOString().slice(5, 7);
          this.APP_NO = result.ActJnlResult.APP_NO;
          this.ANN_NM = result.ActJnlResult.ANN_NM;
          this.BIZNM = result.ActJnlResult.BIZNM;
          this.ANN_ACTCOMP_NO = result.ActJnlResult.ANN_ACTCOMP_NO;
          this.ACTCOMP_NM = result.ActJnlResult.ACTCOMP_NM;
          this.ACT_ING_STEP_NM = result.ActJnlResult.ACT_ING_STEP_NM;
          this.ACT_ING_STEP = result.ActJnlResult.ACT_ING_STEP;

          this.getJnlList();
        }).catch((e) => {
          console.log(e);
        });
    },
    getJnlList() {
      const param = {
        SRCH_ACCYYYY: this.SRCH_ACCYYYY,
        SRCH_ACCMM: this.SRCH_ACCMM,
        APP_NO: this.APP_NO,
        ACTCOMP_NO: this.ACTCOMP_NO,
        ANN_NO: this.annNo,
      };
      Axios.get('/api/act/actJnlList', { params: param })
        .then((response) => {
          const result = response.data.data;

          // null 체크 추가
          if (result && result.list) {
            this.actJnlList = result.list.map((item) => {
              const newItem = { ...item };
              if (!item.ACT_SE_NM) newItem.ACT_SE_NM = '';
              if (!item.ACT_SJ) newItem.ACT_SJ = '';
              if (!item.ACT_DE) newItem.ACT_DE = '';
              if (!item.ACT_STTM) newItem.ACT_STTM = '';
              if (!item.ACT_EDTM) newItem.ACT_EDTM = '';
              if (!item.ACT_TM) newItem.ACT_TM = '';
              if (!item.LUNCH_CD_NM) newItem.LUNCH_CD_NM = '';
              if (!item.DINNER_CD_NM) newItem.DINNER_CD_NM = '';
              if (!item.ADMIT_ACT_TM) newItem.ADMIT_ACT_TM = '';
              if (!item.DAILDOC_CFM_STAT_NM) newItem.DAILDOC_CFM_STAT_NM = '';
              if (!item.SEQ) newItem.SEQ = '';
              if (!item.APP_NO) newItem.APP_NO = this.APP_NO;
              if (!item.ACTCOMP_NO) newItem.ACTCOMP_NO = this.ACTCOMP_NO;
              return newItem;
            });
            this.ActJnlResult = result.ActJnlResult || {};
          } else {
            // 데이터가 없을 때 처리
            this.actJnlList = [];
            this.ActJnlResult = {};
          }

          this.ACCYYYY = this.SRCH_ACCYYYY;
          this.ACCMM = this.SRCH_ACCMM;
        }).catch((e) => {
          console.log(e);
          // 오류 발생시 빈 배열로 초기화
          this.actJnlList = [];
          this.ActJnlResult = {};
        });
    },
    eduCompReport(appNo) {
      window.open(`https://rpt.50plus.or.kr/eduCompReport.do?APP_NO=${appNo}`, 'PopupWin', 'width=1200,height=900');
      // window.open(`/eduCompReport.do?APP_NO=${appNo}`, 'PopupWin', 'width=1200,height=900');
    },
    actJnlRgst() {
      this.actJnlBindData = {
        APP_NO: this.APP_NO,
        BIZNM: this.BIZNM,
        ACCYYYY: this.SRCH_ACCYYYY,
        ACCMM: this.SRCH_ACCMM,
        ACTCOMP_NO: this.ACTCOMP_NO,
        ANN_NO: this.ANN_NO,
        ACTAMT_HAMT: this.ACTAMT_HAMT,
        ANN_ACTCOMP_NO: this.ANN_ACTCOMP_NO,
      };
      this.jnlmode = 'Regist';
      $('body').addClass('modal-open');
      this.actJnlDetailModal = true;
    },
    actJnlView(seq) {
      this.selectedSeq = seq;
      const findData = this.actJnlList.filter(item => item.SEQ === seq);
      this.actJnlBindData = {
        ...findData[0],
        ACCYYYY: this.SRCH_ACCYYYY,
        ACCMM: this.SRCH_ACCMM
      };

      this.jnlmode = 'View';
      $('body').addClass('modal-open');
      this.actJnlDetailModal = true;
    },
    goActList() {
      location.href = '/mypage-ActList.do';
    },
  },
  created() {},
  mounted() {
    this.getJnlMonthList();
  },
};
</script>



// WEBPACK FOOTER //
// ActJnlList.vue?66bbedc3